import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getRZCommercialList} from '../../../../../../../jsx/reducers/paygAdmin/agents';
import { TableRow, TableCell } from '@material-ui/core';

const Checkbox = ({label, isSelected, onCheckboxChange}) => (
    <div>
        <label>
            <input
                type="checkbox"
                name={label}
                checked={isSelected}
                onChange={onCheckboxChange}/>
        </label>
    </div>
);

class ManagementCommercial extends Component {
    state = {
        checkboxes: {},
        list: []
    }
    componentDidMount = () => {
        this
            .props
            .getRZCommercialList(this.props.commercialID)
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.checkboxes !== nextState.checkboxes) {
            console.log("SHOULD STATE BUT DIFFERENT")
            return true
        }
        if (this.props.RZCOMMERCIALLIST !== nextProps.RZCOMMERCIALLIST) {
            console.log("SHOULD PROPS BUT DIFFERENT")
            return true
        }
        console.log("SHOULD SAME")
        return false
    }
    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.RZCOMMERCIALLIST !== prevProps.RZCOMMERCIALLIST) {
            console.log("BUT DIFFERENT")
            //this.props.RZCOMMERCIALLIST.includes(item.id)
            try {
                let list = this.state.list

                this
                    .props
                    .RZCOMMERCIALLIST
                    .map((item, id) => {
                        console.log(item)
                        this.setState(prevState => ({
                            checkboxes: {
                                ...prevState.checkboxes,
                                [item]: !prevState.checkboxes[item]
                            }
                        }));
                        if (list.includes(item)) {
                            var index = list.indexOf(item);
                            if (index !== -1) {
                                list.splice(index, 1);
                            }
                        } else {
                            list.push(item)
                        }
                    })
                this.setState({list: list})

            } catch (error) {
                console.log(error)
            }
            return true
        }
        console.log("SAME")
    }
    handleInputChange(event, id) {
        const target = event.target;
        console.log(target)
        console.log(target.name)
        const value = target.name === id
            ? target.checked
            : target.value;
        const name = target.name;
        console.log(this.state.list)
        let list = this.state.list
        if (list.includes(id)) {
            var index = list.indexOf(id);
            if (index !== -1) {
                list.splice(index, 1);
            }
        } else {
            list.push(id)
        }
        console.log(list)
        this.setState(prevState => ({
            checkboxes: {
                ...prevState.checkboxes,
                [name]: !prevState.checkboxes[name]
            }
        }));
        this.setState({[name]: value, list: list})
        console.log(this.state.list)
        console.log(this.state)
        this
            .props
            .handleChange(this.state.list)
    }
    render() {
        let agentList = [];
        let listAgent = this.props.listAgent;
        console.log(listAgent)
        Object
            .keys(listAgent)
            .map((item, ID) => {
                let agent = listAgent[item]
                if (typeof agent === "undefined") {
                    console.log(item, " - ", ID)
                } else {
                    agentList.push({id: item, externalid: agent.externalid, name: agent.name})
                }
            })
        console.log("Props")
        console.log(this.props.RZCOMMERCIALLIST)
        console.log(this.state.checkboxes)
        return (
            <div
                style={{
                border: '0',
                'overflowY': 'scroll',
                height: "300px"
            }}>
                {agentList.map((item, ID) => {
                    let agent = agentList[ID]
                    //console.log(item.id) console.log(this.state.checkboxes[item.id])
                    return (
                        <TableRow key={ID}>
                            <TableCell >{agent.externalid}</TableCell>
                            <TableCell >{agent.name}</TableCell>
                            <TableCell>
                                <Checkbox
                                    label={item.id}
                                    type="checkbox"
                                    isSelected={this.state.checkboxes[item.id]}
                                    onCheckboxChange={(event) => this.handleInputChange(event, item.id)}/>
                            </TableCell>
                        </TableRow>
                    )
                })
}
            </div>
        )
    }
}
const mapStateToProps1 = (state) => ({RZCOMMERCIALLIST: state.agents.rzcommercialList});

const mapDispatchToProps1 = (dispatch) => ({
    getRZCommercialList: (commercialID) => dispatch(getRZCommercialList(commercialID))
});

export default connect(mapStateToProps1, mapDispatchToProps1)(ManagementCommercial)
